module.exports = __webpack_public_path__ + "img/gb9458.prt.de7d27f2.jpg";